export default __webpack_public_path__ + "static/tabs-independent-dont-8bbb84a79a4f58123dec79192ee7b74dc5c7851a29f21cf1a00c7cedeb1605c6.png";